/**
 * An error class to distinguish from a generic Error, which is usually caused
 * by programmer error. The distinction can be made with the 'instanceof'
 * operator:
 *
 *    try {
 *       // something risky
 *    } catch (err) {
 *       if (err instanceof ApplicationError)
 *          // handle it
 *       else
 *          throw err
 *    }
 */
export function ApplicationError(this: { message: string }, msg: string) {
   this.message = msg;
}

/**
 * An empty error handler function to be used as a default; simply swallows
 * application errors, but allows normal errors to propagate.
 */
export function ignoreApplicationErrors(err: unknown): void {
   if (!(err instanceof (ApplicationError as any))) {
      throw err;
   }
}
